import 'moment/locale/de';
import * as React from 'react';
import { InputGroup, Table } from 'reactstrap';
import { TR } from 'src/TextRes';
import { BookingListLine } from '../../api';
import { ISortIcon } from '../../constants';
import FAIcon from '../fAIcon/FAIcon';
import { IThConfig, SortableTh } from '../sortableTh/SortableTh';
import { TableBox } from '../tableBox/TableBox';

interface IState {
    showMore: boolean[];
}

export interface TableBoxWithCollapseIconProps<T> {
    listData: T[];
    renderTHeadLine: IThConfig[];
    headerStyle?: string;
    sortIcon: ISortIcon[];
    onClickSorting: (sortField: string, index: number, sortIcon: ISortIcon) => void;
}

export interface TableBoxWithCollapseIconObject<T> {
    label: string;
    values: T[];
}

export default class TableBoxWithCollapseIcon extends React.PureComponent<
    TableBoxWithCollapseIconProps<BookingListLine>,
    IState
> {
    constructor(props: TableBoxWithCollapseIconProps<BookingListLine>) {
        super(props);
        this.state = {
            showMore: [],
        };
    }

    public componentDidMount() {
        const showMoreArray: boolean[] = [];
        if (this.props.listData) {
            this.props.listData.map(() => {
                showMoreArray.push(false);
            });
        }
        this.setState({
            showMore: [...showMoreArray],
        });
    }

    public render() {
        const noResultsMessage = TR.tableBoxWithCollapseIcon_no_results;

        if (!this.props.listData || this.props.listData.length < 1) {
            return (
                <legend className="my-3" style={{ color: 'red' }}>
                    {noResultsMessage}
                </legend>
            );
        }

        const renderTHeadLine = (
            <tr>
                {this.props.renderTHeadLine.map((str: IThConfig, index: number) => {
                    return (
                        <SortableTh
                            key={str.name + index}
                            index={index}
                            sortIcon={this.props.sortIcon[index]}
                            sortField={str.sortField}
                            onClickSorting={this.props.onClickSorting}
                            widthStyle={str.width}
                            name={str.name}
                        />
                    );
                })}
            </tr>
        );

        return (
            <TableBox
                listData={this.props.listData}
                renderTBodyLine={this.renderTBodyLine}
                renderTHeadLine={renderTHeadLine}
            />
        );
    }

    private renderTBodyLine = (value: BookingListLine, index: number) => {
        return (
            <React.Fragment key={value.FirstName + value.LastName + (index + 1)}>
                <tr>
                    <td>
                        <a
                            onClick={() => {
                                const showMoreN: boolean[] = this.state.showMore;
                                showMoreN[index] = !showMoreN[index];
                                this.setState({
                                    showMore: [...showMoreN],
                                });
                            }}
                            className=" pull-right"
                        >
                            {this.state.showMore[index] ? (
                                <FAIcon mouseHover="Weniger anzeigen" icon="minus-circle" />
                            ) : (
                                <FAIcon mouseHover="Mehr anzeigen" icon="plus-circle" />
                            )}
                        </a>
                    </td>
                    <td>
                        <InputGroup>{value.CourseProviderName}</InputGroup>
                    </td>
                    <td>{value.CourseName}</td>
                    <td>{value.Lecturer}</td>
                    <td>{value.BookingsDate}</td>
                    <td>{value.CourseDate}</td>
                    <td>{value.FirstName + ' ' + value.LastName}</td>
                    <td>
                        {this.formatNumber(value.BookingOptionPrice)}
                        &nbsp;€
                    </td>
                    <td>
                        {this.formatNumber(value.Provision)}
                        &nbsp;€
                    </td>
                    <td>{value.BookingOptionName}</td>
                </tr>

                {this.state.showMore[index] && (
                    <tr>
                        <td colSpan={10}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>{TR.tableBoxWithCollapseIcon_name}</th>
                                        <th>{TR.tableBoxWithCollapseIcon_address}</th>
                                        <th>{TR.tableBoxWithCollapseIcon_telephone}</th>
                                        <th>{TR.tableBoxWithCollapseIcon_email}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{value.FirstName + ' ' + value.LastName}</td>
                                        <td>
                                            {value.Street && value.Street !== '' ? (
                                                <>
                                                    {value.Street}, &nbsp;
                                                    {value.Zip}
                                                    &nbsp;
                                                    {value.City}
                                                </>
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td>{value.Telephone && value.Telephone !== '' ? value.Telephone : '-'}</td>
                                        <td>{value.Email && value.Email !== '' ? value.Email : '-'}</td>
                                    </tr>
                                    {value.Note && value.Note !== '' && (
                                        <tr>
                                            <td colSpan={4} className="text-center">
                                                {value.Note}
                                            </td>
                                        </tr>
                                    )}
                                    {value.Rejected && value.Reason && value.Reason !== '' && (
                                        <tr>
                                            <td colSpan={4} className="text-center">
                                                {value.Reason}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                )}
            </React.Fragment>
        );
    };

    private formatNumber = (n: number) => {
        return n.toLocaleString('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            useGrouping: false,
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/tableBoxWithCollapseIcon/TableBoxWithCollapseIcon.tsx